import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-b5ff48f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "チュートリアル")
], -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "video-container" }
const _hoisted_5 = {
  key: 0,
  src: "video/sp/01_tutorial_controller.mp4",
  poster: "video/sp/01_tutorial_controller.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_6 = {
  key: 1,
  src: "video/pc/01_tutorial_controller.mp4",
  poster: "video/pc/01_tutorial_controller.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "移動方法", -1))
const _hoisted_8 = {
  key: 0,
  src: "video/sp/02_character_talk.mp4",
  poster: "video/sp/02_character_talk.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_9 = {
  key: 1,
  src: "video/pc/02_character_talk.mp4",
  poster: "video/pc/02_character_talk.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "キャラクターとの会話", -1))
const _hoisted_11 = {
  key: 0,
  src: "video/sp/03_quiz.mp4",
  poster: "video/sp/03_quiz.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_12 = {
  key: 1,
  src: "video/pc/03_quiz.mp4",
  poster: "video/pc/03_quiz.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "クイズへの挑戦", -1))
const _hoisted_14 = {
  key: 0,
  src: "video/sp/04_sp_tutorial_map.mp4",
  poster: "video/sp/04_sp_tutorial_map.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_15 = {
  key: 1,
  src: "video/pc/04_tutorial_map.mp4",
  poster: "video/pc/04_tutorial_map.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "MAP", -1))
const _hoisted_17 = {
  key: 0,
  src: "video/sp/05_tutorial_pavilion.mp4",
  poster: "video/sp/05_tutorial_pavilion.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_18 = {
  key: 1,
  src: "video/pc/05_tutorial_pavilion.mp4",
  poster: "video/pc/05_tutorial_pavilion.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "パビリオン入場の方法", -1))
const _hoisted_20 = {
  key: 0,
  src: "video/sp/06_tutorial_trophy.mp4",
  poster: "video/sp/06_tutorial_trophy.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_21 = {
  key: 1,
  src: "video/pc/06_tutorial_trophy.mp4",
  poster: "video/pc/06_tutorial_trophy.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "トロフィーの獲得", -1))
const _hoisted_23 = {
  key: 0,
  src: "video/sp/07_tutorial_nomal_bird.mp4",
  poster: "video/sp/07_tutorial_nomal_bird.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_24 = {
  key: 1,
  src: "video/pc/07_tutorial_nomal_bird.mp4",
  poster: "video/pc/07_tutorial_nomal_bird.png",
  muted: "",
  playsinline: "",
  controls: ""
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "視点切替", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass({ tutorial: _ctx.step === 0 }),
    ref: "main"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          (_ctx.mobile)
            ? (_openBlock(), _createElementBlock("video", _hoisted_5))
            : (_openBlock(), _createElementBlock("video", _hoisted_6)),
          _hoisted_7
        ]),
        _createElementVNode("div", null, [
          (_ctx.mobile)
            ? (_openBlock(), _createElementBlock("video", _hoisted_8))
            : (_openBlock(), _createElementBlock("video", _hoisted_9)),
          _hoisted_10
        ]),
        _createElementVNode("div", null, [
          (_ctx.mobile)
            ? (_openBlock(), _createElementBlock("video", _hoisted_11))
            : (_openBlock(), _createElementBlock("video", _hoisted_12)),
          _hoisted_13
        ]),
        _createElementVNode("div", null, [
          (_ctx.mobile)
            ? (_openBlock(), _createElementBlock("video", _hoisted_14))
            : (_openBlock(), _createElementBlock("video", _hoisted_15)),
          _hoisted_16
        ]),
        _createElementVNode("div", null, [
          (_ctx.mobile)
            ? (_openBlock(), _createElementBlock("video", _hoisted_17))
            : (_openBlock(), _createElementBlock("video", _hoisted_18)),
          _hoisted_19
        ]),
        _createElementVNode("div", null, [
          (_ctx.mobile)
            ? (_openBlock(), _createElementBlock("video", _hoisted_20))
            : (_openBlock(), _createElementBlock("video", _hoisted_21)),
          _hoisted_22
        ]),
        _createElementVNode("div", null, [
          (_ctx.mobile)
            ? (_openBlock(), _createElementBlock("video", _hoisted_23))
            : (_openBlock(), _createElementBlock("video", _hoisted_24)),
          _hoisted_25
        ])
      ])
    ]),
    (_ctx.mobile)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _imports_0,
          class: "page-top",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pageTop && _ctx.pageTop(...args)))
        }))
      : _createCommentVNode("", true)
  ], 2))
}